import React from 'react';
import CashManage from '../containers/CashManage/CashManage';

const CashManagePage: React.FC = () => {
  return (<CashManage />);
};

export default CashManagePage;
